"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");

var component_1 = require("./");

var context_1 = require("../context");

var data_1 = require("../data");

exports.initialContactMapState = {
  pointsToPlot: new Array()
};

var ContactMapClass =
/** @class */
function (_super) {
  __extends(ContactMapClass, _super);

  function ContactMapClass(props) {
    var _this = _super.call(this, props) || this;

    _this.state = exports.initialContactMapState;

    _this.onNodeSizeChange = function (index) {
      return function (value) {
        var pointsToPlot = _this.state.pointsToPlot;

        _this.setState({
          pointsToPlot: __spread(pointsToPlot.slice(0, index), [__assign({}, pointsToPlot[index], {
            nodeSize: value
          })], pointsToPlot.slice(index + 1))
        });
      };
    };

    _this.generateNodeSizeSliderConfigs = function (entries) {
      return entries.map(function (entry, index) {
        return {
          id: "node-size-slider-" + index,
          name: "Node size for " + entry.name,
          onChange: _this.onNodeSizeChange(index),
          type: data_1.CONFIGURATION_COMPONENT_TYPE.SLIDER,
          values: {
            current: entry.nodeSize,
            max: 20,
            min: 1
          }
        };
      });
    };

    _this.onMouseEnter = function (cb) {
      return function (e) {
        var e_1, _a, e_2, _b;

        if (e.isAxis()) {
          var _c = _this.props,
              secondaryStructureContext = _c.secondaryStructureContext,
              data = _c.data;

          try {
            for (var _d = __values(data.secondaryStructures), _e = _d.next(); !_e.done; _e = _d.next()) {
              var secondaryStructure = _e.value;

              try {
                for (var secondaryStructure_1 = __values(secondaryStructure), secondaryStructure_1_1 = secondaryStructure_1.next(); !secondaryStructure_1_1.done; secondaryStructure_1_1 = secondaryStructure_1.next()) {
                  var section = secondaryStructure_1_1.value;

                  if (section.contains.apply(section, __spread(e.selectedPoints))) {
                    secondaryStructureContext.addHoveredSecondaryStructure(section);
                  }
                }
              } catch (e_2_1) {
                e_2 = {
                  error: e_2_1
                };
              } finally {
                try {
                  if (secondaryStructure_1_1 && !secondaryStructure_1_1.done && (_b = secondaryStructure_1.return)) _b.call(secondaryStructure_1);
                } finally {
                  if (e_2) throw e_2.error;
                }
              }
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        } else {
          cb(e.selectedPoints);
        }
      };
    };

    _this.onMouseLeave = function (cb) {
      return function (e) {
        var e_3, _a, e_4, _b;

        if (e.isAxis()) {
          var _c = _this.props,
              data = _c.data,
              secondaryStructureContext = _c.secondaryStructureContext;

          try {
            for (var _d = __values(data.secondaryStructures), _e = _d.next(); !_e.done; _e = _d.next()) {
              var secondaryStructure = _e.value;

              try {
                for (var secondaryStructure_2 = __values(secondaryStructure), secondaryStructure_2_1 = secondaryStructure_2.next(); !secondaryStructure_2_1.done; secondaryStructure_2_1 = secondaryStructure_2.next()) {
                  var section = secondaryStructure_2_1.value;

                  if (section.contains.apply(section, __spread(e.selectedPoints))) {
                    secondaryStructureContext.removeHoveredSecondaryStructure(section);
                  }
                }
              } catch (e_4_1) {
                e_4 = {
                  error: e_4_1
                };
              } finally {
                try {
                  if (secondaryStructure_2_1 && !secondaryStructure_2_1.done && (_b = secondaryStructure_2.return)) _b.call(secondaryStructure_2);
                } finally {
                  if (e_4) throw e_4.error;
                }
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            } finally {
              if (e_3) throw e_3.error;
            }
          }
        } else if (cb) {
          cb(e.selectedPoints);
        }
      };
    };

    _this.onMouseClick = function (cb) {
      return function (e) {
        var e_5, _a, e_6, _b;

        if (e.isAxis()) {
          var _c = _this.props,
              data = _c.data,
              secondaryStructureContext = _c.secondaryStructureContext;

          try {
            for (var _d = __values(data.secondaryStructures), _e = _d.next(); !_e.done; _e = _d.next()) {
              var secondaryStructure = _e.value;

              try {
                for (var secondaryStructure_3 = __values(secondaryStructure), secondaryStructure_3_1 = secondaryStructure_3.next(); !secondaryStructure_3_1.done; secondaryStructure_3_1 = secondaryStructure_3.next()) {
                  var section = secondaryStructure_3_1.value;

                  if (section.contains.apply(section, __spread(e.selectedPoints))) {
                    if (secondaryStructureContext.selectedSecondaryStructures.includes(section)) {
                      secondaryStructureContext.removeSecondaryStructure(section);
                    } else {
                      secondaryStructureContext.addSelectedSecondaryStructure(section);
                    }
                  }
                }
              } catch (e_6_1) {
                e_6 = {
                  error: e_6_1
                };
              } finally {
                try {
                  if (secondaryStructure_3_1 && !secondaryStructure_3_1.done && (_b = secondaryStructure_3.return)) _b.call(secondaryStructure_3);
                } finally {
                  if (e_6) throw e_6.error;
                }
              }
            }
          } catch (e_5_1) {
            e_5 = {
              error: e_5_1
            };
          } finally {
            try {
              if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            } finally {
              if (e_5) throw e_5.error;
            }
          }
        } else {
          cb(e.selectedPoints);
        }
      };
    };

    _this.onMouseSelect = function (cb) {
      return function (e) {
        if (cb) {
          // For the contact map, all the x/y values are mirrored and correspond directly with i/j values.
          // Thus, all the residue numbers can be obtained by getting either all x or values from ths selected points.
          cb(e.selectedPoints.map(function (point) {
            return point;
          }));
        }
      };
    };

    return _this;
  }

  ContactMapClass.prototype.componentDidMount = function () {
    this.setupPointsToPlot(this.props.data.couplingScores);
  };

  ContactMapClass.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        data = _a.data,
        residueContext = _a.residueContext;

    if (data !== prevProps.data || residueContext.lockedResiduePairs !== prevProps.residueContext.lockedResiduePairs) {
      this.setupPointsToPlot(data.couplingScores);
    }
  };

  ContactMapClass.prototype.render = function () {
    var _a = this.props,
        configurations = _a.configurations,
        isDataLoading = _a.isDataLoading,
        residueContext = _a.residueContext,
        style = _a.style;
    var pointsToPlot = this.state.pointsToPlot;
    return React.createElement("div", {
      className: "ContactMapComponent",
      style: __assign({}, style)
    }, React.createElement(semantic_ui_react_1.Dimmer.Dimmable, {
      dimmed: true
    }, React.createElement(semantic_ui_react_1.Dimmer, {
      active: isDataLoading
    }, React.createElement(semantic_ui_react_1.Loader, null)), this.renderContactMapChart(pointsToPlot, __spread([{
      name: 'Clear Selections',
      onClick: residueContext.removeAllLockedResiduePairs,
      type: data_1.CONFIGURATION_COMPONENT_TYPE.BUTTON
    }], configurations, this.generateNodeSizeSliderConfigs(pointsToPlot)))));
  };

  ContactMapClass.prototype.setupPointsToPlot = function (couplingContainer) {
    var _a = this.props,
        formattedPoints = _a.formattedPoints,
        observedColor = _a.observedColor,
        highlightColor = _a.highlightColor,
        residueContext = _a.residueContext;
    var pointsToPlot = this.state.pointsToPlot;
    var chartNames = {
      known: 'Known Structure Contact',
      selected: 'Selected Residue Pairs'
    };
    var knownPointsIndex = pointsToPlot.findIndex(function (entry) {
      return entry.name === chartNames.known;
    });
    var selectedPointIndex = pointsToPlot.findIndex(function (entry) {
      return entry.name === chartNames.selected;
    });
    var observedContactPoints = couplingContainer.getObservedContacts();
    var result = new (Array.bind.apply(Array, __spread([void 0, component_1.generateChartDataEntry('text', {
      start: observedColor,
      end: 'rgb(100,177,200)'
    }, chartNames.known, '(from PDB structure)', knownPointsIndex >= 0 ? pointsToPlot[knownPointsIndex].nodeSize : 4, observedContactPoints, {
      text: observedContactPoints.map(function (point) {
        var score = couplingContainer.getCouplingScore(point.i, point.j);
        return score && score.A_i && score.A_j ? "(" + point.i + score.A_i + ", " + point.j + score.A_j + ")" : "(" + point.i + ", " + point.j + ")";
      })
    })], formattedPoints)))();
    var lockedResiduePairs = residueContext.lockedResiduePairs,
        hoveredResidues = residueContext.hoveredResidues;
    var chartPoints = new Array();

    if (hoveredResidues.length >= 1) {
      chartPoints.push({
        i: hoveredResidues[0],
        j: hoveredResidues.length === 1 ? hoveredResidues[0] : hoveredResidues[1]
      });
    }

    if (lockedResiduePairs.size >= 1) {
      chartPoints.push.apply(chartPoints, __spread(Array.from(lockedResiduePairs.keys()).reduce(function (reduceResult, key) {
        var keyPair = lockedResiduePairs.get(key);

        if (keyPair && keyPair.length === 2) {
          reduceResult.push({
            i: keyPair[0],
            j: keyPair[1],
            dist: 0
          });
        }

        return reduceResult;
      }, new Array())));
    }

    result.push(component_1.generateChartDataEntry('none', highlightColor, chartNames.selected, '', selectedPointIndex >= 0 ? pointsToPlot[selectedPointIndex].nodeSize : 6, chartPoints, {
      marker: {
        color: new Array(chartPoints.length * 2).fill(highlightColor),
        line: {
          color: highlightColor,
          width: 3
        },
        symbol: 'circle-open'
      }
    }));
    this.setState(__assign({}, this.state, {
      pointsToPlot: __spread(result)
    }));
  };

  ContactMapClass.prototype.renderContactMapChart = function (pointsToPlot, configurations) {
    var _a = this.props,
        data = _a.data,
        height = _a.height,
        onBoxSelection = _a.onBoxSelection,
        residueContext = _a.residueContext,
        showConfigurations = _a.showConfigurations,
        secondaryStructureContext = _a.secondaryStructureContext,
        width = _a.width;
    return React.createElement(component_1.ContactMapChart, {
      candidateResidues: residueContext.candidateResidues,
      configurations: configurations,
      contactData: pointsToPlot,
      height: height,
      onClickCallback: this.onMouseClick(residueContext.toggleLockedResiduePair),
      onHoverCallback: this.onMouseEnter(residueContext.addHoveredResidues),
      onSelectedCallback: this.onMouseSelect(onBoxSelection),
      onUnHoverCallback: this.onMouseLeave(residueContext.removeHoveredResidues),
      range: data.couplingScores.residueIndexRange.max + 20,
      secondaryStructures: data.pdbData ? data.pdbData.secondaryStructureSections : [],
      showConfigurations: showConfigurations,
      selectedSecondaryStructures: [secondaryStructureContext.selectedSecondaryStructures],
      width: width
    });
  };

  ContactMapClass.defaultProps = {
    configurations: new Array(),
    data: {
      couplingScores: new data_1.CouplingContainer(),
      secondaryStructures: new Array()
    },
    enableSliders: true,
    formattedPoints: new Array(),
    height: '100%',
    highlightColor: '#ff8800',
    isDataLoading: false,
    observedColor: '#0000ff',
    residueContext: __assign({}, context_1.initialResidueContext),
    secondaryStructureContext: __assign({}, context_1.initialSecondaryStructureContext),
    showConfigurations: true,
    width: '100%'
  };
  return ContactMapClass;
}(React.Component);

exports.ContactMapClass = ContactMapClass;

var ContactMap = function ContactMap(props) {
  return React.createElement(context_1.ResidueContextConsumer, null, function (residueContext) {
    return React.createElement(context_1.SecondaryStructureContextConsumer, null, function (secondaryStructureContext) {
      return React.createElement(ContactMapClass, __assign({
        residueContext: residueContext,
        secondaryStructureContext: secondaryStructureContext
      }, props));
    });
  });
};

exports.ContactMap = ContactMap;